import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import NewsCategorySelector from './NewsCategorySelector';
import ChangeMonthCalendar from '../ChangeMonthCalendar';
import SearchWindow from '../../../Components/SearchWindow/SearchWindow';
import BrownButton from '../../../Components/Buttons/BrownButton';
import CommonSvgSelector from '../../../assets/common/SVG/CommonSvgSelector';
import {useClickOutside} from '../../../hooks/useClickOutside';
import {infoType} from '../../../types/TypesNews';
import s from '../MediaAndNews.module.css';
import {useNewsFilters} from '../hooks/useNewsFilters';

type FiltersType = ReturnType<typeof useNewsFilters>;

type Props = {
	filters: FiltersType;
	categoriesList: infoType[] | null;
};

const NewsFilters: React.FC<Props> = ({filters, categoriesList}) => {
	const {t} = useTranslation();

	const handleCloseCalendar = useCallback(() => {
		filters.setOpenCalendar(false);
	}, [filters]);

	const handleCloseSearchInput = useCallback(() => {
		filters.setOpenSearchInput(false);
	}, [filters]);

	const calendarContainerRef = useClickOutside<HTMLDivElement>(handleCloseCalendar);
	const searchInputContainerRef = useClickOutside<HTMLDivElement>(
		handleCloseSearchInput,
	);

	const handleClickClearMonthButton = useCallback(() => {
		filters.setCurrentMonth(null);
		filters.setCurrentMonthName(t('По місяцю'));
	}, [filters, t]);

	const handleChangeInputSearch = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			filters.setCurrentText(event.currentTarget.value);
		},
		[filters],
	);

	const handleToggleCalendar = useCallback(() => {
		filters.setOpenCalendar(!filters.openCalendar);
	}, [filters]);

	const handleToggleSearch = useCallback(() => {
		filters.setOpenSearchInput(!filters.openSearchInput);
	}, [filters]);

	return (
		<div className="media-header__row">
			<NewsCategorySelector
				open={filters.openCategory}
				setCurrentCategoryName={filters.setCurrentCategoryName}
				setOpen={filters.setOpenCategory}
				buttonText={t('По категорії')}
				currentCategoryName={filters.currentCategoryName}
				categoriesList={categoriesList}
				handleChangeCategory={filters.handleChangeCategory}
			/>
			<div ref={calendarContainerRef}>
				<div className={s.buttonContainer}>
					<BrownButton
						text={filters.currentMonthName}
						onClick={handleToggleCalendar}
						type="button"
						className="media-header__btnInCalendar media-header__btn"
					/>
					{filters.currentMonthName !== t('По місяцю') && (
						<button
							type="button"
							onClick={handleClickClearMonthButton}
							className={s.clearButton}
							aria-label={t('Очистити місяць')}
						>
							<CommonSvgSelector id={'deleteCross'} />
						</button>
					)}
				</div>
				{filters.openCalendar && (
					<ChangeMonthCalendar
						close={filters.setOpenCalendar}
						setCurrentMonthName={filters.setCurrentMonthName}
						setCurrentMonth={filters.setCurrentMonth}
					/>
				)}
			</div>

			<div ref={searchInputContainerRef}>
				<BrownButton
					text={t('По словам')}
					onClick={handleToggleSearch}
					type="button"
					className="media-header__btn"
				/>
				{filters.openSearchInput && (
					<div className={s.searchInputContainer}>
						<SearchWindow
							handleSubmit={filters.handleClickLupa}
							handleClick={filters.handleClickLupa}
							value={filters.currentText || ''}
							handleChange={handleChangeInputSearch}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default NewsFilters;

